import React from "react";
import Button from "@mui/material/Button";
import { useNavigate, useLocation } from "react-router-dom";
import { AppUrl } from "../config";

interface Props {
  buttonLabel: string;
  app: string;
  backButtonURL: any;
  resetState: (app: string) => void;
  currentApp: string;
  disabled?: boolean;
  variant?: "dark";
}
function BackButton({
  buttonLabel,
  app,
  backButtonURL,
  resetState,
  currentApp,
  disabled,
  variant,
}: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  function backButton() {
    if (location?.state?.url) {
      navigate(location?.state?.url);
    } else if (sessionStorage.getItem("prevUrl")) {
      const url = sessionStorage.getItem("prevUrl");
      sessionStorage.removeItem("prevUrl");
      navigate(url);
    } else {
      app === "API"
        ? (window.location.href = AppUrl(app))
        : navigate(AppUrl(app));
      resetState(currentApp);
    }
  }

  return (
    <Button
      sx={
        variant === "dark"
          ? {
              width: 240,
              height: 32,
            }
          : {
              width: 160,
              height: 40,
              fontSize: "1rem",
              padding: 0,
              fontWeight: 400,
              margin: 0,
            }
      }
      id={buttonLabel.replace(/\s+/g, "-").toLowerCase()}
      onClick={backButton}
      disabled={disabled}
      variant="contained"
      color={variant === "dark" ? "primary" : "secondary"}
      disableElevation
    >
      {buttonLabel}
    </Button>
  );
}
export default BackButton;
